import React, { useState, useEffect } from "react";
import { Table, TableColumn } from "../../../components/table";
import TextBox from "../../../components/textfield/textbox";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import { Input } from "../../../components/textfield";
import Icon from "@mdi/react";
import { mdiFileUploadOutline } from "@mdi/js";
import "../../../assets/styles/admin/usedcourse.scss";

const Courserenew1 = () => {
  const history = useHistory();
  const columns = [
    {
      title: "No",
    },
    {
      title: "รายการ",
    },
    {
      title: "ทั้งหมด",
      align: "center",
    },
    {
      title: "ใช้ไปแล้ว",
      align: "center",
    },
    {
      title: "คงเหลือ",
      align: "center",
    },
    {
      title: "หมดอายุ",
      align: "center",
    },
    {
      title: "ต่ออายุ",
      align: "center",
    },
    {
      title: "ใบขอรับบริการ",
      align: "center",
    },
    {
      title: "ใบต่ออายุคอร์ส",
      align: "center",
    },
    {
      title: "สถานะคอร์ส",
      align: "center",
    },
  ];

  const data2 = [
    {
      _id: 1,
      list: "Dual Yellow 5 Times",
      total: "5,000.00",
      used: "1,000.00",
      remaining: "4,000.00",
      empire_date: "26-01-2564",
      renew_date: "26-07-2564",
      statuscourse: "Renewal",
    },
  ];
  return (
    <div>
      <HeaderBar title="ต่ออายุคอร์ส" btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}
      <div style={{ padding: "20px 40px" }}>
        <div className="card-view" style={{ padding: "30px 10px" }}>
          <div className="row" style={{ padding: "0px 40px" }}>
            <TextBox
              className="col-3 text-box-usedc"
              title="Customer"
              value="Ms.A"
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="CN"
              value="Ek-CNF60100015"
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="SO"
              value="SO-PRO-63010147"
            />
            <Input
              className="col-3 input-usedc"
              title="DATE"
              type="date"
              value="2564-01-18"
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            <Table header={columns}>
              {data2.map((item, index) => (
                <tr
                  key={index}
                  // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                  style={{ cursor: "pointer" }}
                >
                  <TableColumn width="3%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="20%">{item.list}</TableColumn>
                  <TableColumn width="5%" align="right">
                    {item.total}
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    {item.used}
                  </TableColumn>
                  <TableColumn width="5%" align="right">
                    {item.remaining}
                  </TableColumn>
                  <TableColumn width="10%" align="center">
                    {item.empire_date}
                  </TableColumn>
                  <TableColumn width="10%" align="center">
                    {item.renew_date}
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    <div className="radious-upload">
                      <Icon
                        path={mdiFileUploadOutline}
                        size="20"
                        color="#fff"
                      />
                    </div>
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    <div className="radious-upload">
                      <Icon
                        path={mdiFileUploadOutline}
                        size="20"
                        color="#fff"
                      />
                    </div>
                  </TableColumn>
                  <TableColumn width="10%" align="center">
                    {item.statuscourse}
                  </TableColumn>
                </tr>
              ))}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Courserenew1;
